// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"796b6672","399":"62b39ef7"}[chunkId] + ".chunk.css";
};